/*! LQ NameSpace | Copyright 2015 Loto Quebec Inc. */
/*global jQuery,lq,console*/
/*jshint -W030*/
;
(function($, document, window, lq) {
    'use strict';
    var carrouselNum = 1;
    $('.fn-carousel').each(function() {
        var carousel = $(this);
        var nbenfants = carousel.children();
        var posal = 0;
        if (carousel.data('randomstart') && typeof(nbenfants) != 'undefined' && nbenfants != null) {
            posal = Math.round(nbenfants.length * Math.random() - 0.5);
        }

        carousel.owlCarousel({
            onInitialized: function() {
                //Pour éviter de lire les éléments clonées sur un lecteur d'écran
                carousel.find('.cloned').attr("aria-hidden", "true");
                carousel.find('.cloned a,.cloned button').attr("tabindex", "-1");
            },
            loop: (carousel.data('loop') || true),
            margin: 10,
            nav: (carousel.data('nav') || false),
            startPosition: posal,
            autoWidth: false,
            animateOut: 'fadeOut',
            animateIn: 'fadeIn',
            stagePadding: 0,
            smartSpeed: (carousel.data('autoplay-speed') || 450),
            slideBy: (carousel.data('slide-by') || 1),
            autoplay: true,
            autoplayTimeout: (carousel.data('autoplay-timeout') || 8000),
            autoplayHoverPause: true,
            navText: [
                '<span class="sr-only">' + (carousel.data('nav-text-prev') || lq.i18n.get('nav-text-prev')) + '</span>‹',
                '<span class="sr-only">' + (carousel.data('nav-text-next') || lq.i18n.get('nav-text-next')) + '</span>›'
            ],
            URLhashListener: true,

            responsive: {

                0: {
                    items: (carousel.data('responsive-items-small') || 1),
                },
                768: {
                    items: (carousel.data('responsive-items-medium') || 1),
                },
                992: {
                    items: (carousel.data('responsive-items-large') || 1),
                },
                1200: {
                    items: (carousel.data('responsive-items-xlarge') || 1)
                }

            },

            onTranslate: function() {
                resetProgressBar();
                startProgressBar();
            },
            onDragged: function() {
                deactivateCarousel();
            },
        })

        var animation = "fillBar " + (carousel.data('autoplay-timeout') || 8000) + "ms linear infinite"
        setTimeout(function() {
            $('.progress-bar', carousel).css("animation", animation);
        });

        $('.owl-dots', carousel).attr('aria-hidden', true);
        $('.owl-dot', carousel).attr("tabindex", "-1");

        var activeCarousel = true;
        var carouselContainer = carousel.parent();
        var enfants = carousel.find('.owl-item:not(.cloned)');
        /* Calcul du numéro de slide (Stats) */
        var slideNum = 1;
        $('.owl-item:not(.cloned)', carousel).each(function(e) {
            $(this).find("a.card.carrousel").attr("data-num-banniere", "carrousel-" + carrouselNum + "-slide-num-" + slideNum.toString());
            $(this).find("a.card.carrousel img.card-img").attr("data-num-banniere", "carrousel-" + carrouselNum + "-slide-num-" + slideNum.toString());
            $(this).find("a.card.carrousel button.btn").attr("data-num-banniere", "carrousel-" + carrouselNum + "-slide-num-" + slideNum.toString());
            slideNum++;
        });
        if (enfants.length > 1) {
            var progressBarHtml = '<div class="progress"><div class="progress-bar" role="progressbar" aria-hidden="true"></div></div>'
            $('.card-img-overlay', this).append(progressBarHtml);
        } else {
            $('.play, .stop', carouselContainer).remove();
            enfants.addClass('disable-drag');
            activeCarousel = false;
        }
        activateCarousel();
        configureMouseEvents();

        function configureMouseEvents() {
            $('.play', carouselContainer).on('click', function() {
                activateCarousel();
            })
            $('.stop', carouselContainer).on('click', function() {
                deactivateCarousel();
            })
            $('.owl-prev, .owl-next, .owl-item, .owl-dot', this).on('click', function() {
                deactivateCarousel();
            });
            carousel.on("focus mouseenter", function() {
                stopProgressBar();
            });
            carousel.on("focusout mouseleave", function() {
                resumeProgressBar();
            });
            $(".disable-drag", carousel).on("touchstart mousedown", function(event) {
                event.stopPropagation();
            });
        }

        function activateCarousel() {
            if (!activeCarousel) {
                activeCarousel = true;
                carousel.trigger('play.owl.autoplay');
            }
            resetProgressBar();
            startProgressBar();
            $('.play', carouselContainer).css({ 'display': 'none' });
            $('.stop', carouselContainer).css({ 'display': 'inline-block' });
            $('.progress', carousel).css({ 'display': 'flex' });
        }

        function deactivateCarousel() {
            activeCarousel = false;
            carousel.trigger('stop.owl.autoplay');
            $('.play', carouselContainer).css({ 'display': 'inline-block' });
            $('.stop', carouselContainer).css({ 'display': 'none' });
            $('.progress', carousel).css({ 'display': 'none' });
            resetProgressBar();
        }

        function startProgressBar() {
            setTimeout(function() {
                $('.progress-bar', carousel).css("animation", animation);
            });
        }

        function resumeProgressBar() {
            if (activeCarousel) {
                $('.progress-bar', carousel).css("animation-play-state", "running");
            }
        }

        function stopProgressBar() {
            $('.progress-bar', carousel).css("animation-play-state", "paused");
        }

        function resetProgressBar() {
            $('.progress-bar', carousel).css({
                "animation": "none",
                "width": "0%"
            });
        }
        carrouselNum++;
    });



    // Update global scope lq namespace
    window.lq = lq;

    // Auto trigger all self implemented (plugin) functionalities
    lq.load.push(
        "lq.utils", [
            'setupCarousel'
        ]
    );

}(jQuery, document, window, (window.lq || {})));